import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { axios } from '@/services/axios';

function useRequestNumberBlock({ id, currentCompany, qk }) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (selectedRow) => {
            try {
                const payload = selectedRow;
                return axios.post(
                    `/numberblock/requestexisting/${currentCompany}/${id}`,
                    {
                        data: payload,
                    },
                );
            } catch (error) {
                throw new Error(
                    error?.message || 'Failed to request number block',
                );
            }
        },
        onError: (error) => {
            let errorMessage = 'Failed to request number block';
            if (error?.response.status === 401) {
                errorMessage =
                    'Endpoint not accessible with current permissions';
            } else {
                errorMessage = error?.response?.data?.message;
            }
            toast.error(errorMessage);
        },
        onSuccess: () => {
            return queryClient.invalidateQueries({
                queryKey: [qk, currentCompany],
            });
        },
    });
}

export { useRequestNumberBlock };
